import { SYSTEM_ROLE_CODE } from "@/schemas/user";
import useAccount from "./useAccount";

/** True when the current account has system administrator role */
export const useIsAdmin = (): boolean => {
  const { account } = useAccount();
  return account?.system_role_code === SYSTEM_ROLE_CODE.SYSTEM_ADMINISTRATOR;
};
